import React from 'react';
import PropTypes from 'prop-types';
import { ContainerDiv, CancelButton, StyledText } from './StyledComponents';
import CancelIcon from '../../assets/svgIcon/cancelIcon';
import { safeDecodeURIComponent } from '../../utils/helper.utils';

function UploadedItem({ name, onRemove, margin, padding, backgroundColor, height ,checkAccess=true, disabled}) {
  return (
    <ContainerDiv
      margin={margin}
      backgroundColor={backgroundColor}
      height={height}
      padding={padding}
    >
     {(checkAccess === true && !disabled) ?
      <CancelButton onClick={onRemove} disabled={disabled}>
        <CancelIcon />
      </CancelButton> :""}
      <StyledText>{name ? safeDecodeURIComponent(name) : ""}</StyledText>
    </ContainerDiv>
  );
}

export default UploadedItem;

UploadedItem.propTypes = {
  name: PropTypes.string,
  onRemove: PropTypes.func,
  backgroundColor: PropTypes.string,
  checkAccess: PropTypes.string,
};
